// Static design assets (icons, illustrations, logos) live in `src/public/assets` and are
// fetched at runtime. `import.meta.env.BASE_URL` carries the base the portal is served under
// (`/` in local dev), so every asset URL resolves from the deployment root.
export const ASSET_BASE = import.meta.env.BASE_URL + 'assets/';
export const asset = (path: string): string => ASSET_BASE + path;
